import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import TemplateContent from '@/components/common/template-editor';
import { transformParamsToDataV2, transformParamsToForm, transformParamsToFormV2, transformToForm } from "@/components/common/transformData";
import { getParamDetail as _getParamDetail, getParamList, updateParam as _updateParam, removeParam as _removeParam, createParam as _createParam } from "@/api/correspondence/task/form";
import { getAccountList } from "@/api/correspondence/task";
import _toPreviewData from "@/views/correspondence/task/components/util/preview-data";
export default {
  name: "template-dialog",
  components: {
    TemplateContent: TemplateContent
  },
  props: {
    id: {},
    isInCorrespondence: {},
    editVal: {
      default: function _default() {
        return undefined;
      }
    },
    onlyRead: {
      default: function _default() {
        return false;
      }
    },
    taskId: {
      default: function _default() {
        return undefined;
      }
    },
    params: {
      default: function _default() {
        return [];
      }
    },
    sysParams: {
      default: function _default() {
        return {};
      }
    },
    data: {
      default: function _default() {
        return {};
      }
    },
    type: {
      default: function _default() {
        return 'create';
      }
    },
    confirmId: {
      default: function _default() {
        return undefined;
      }
    },
    canBePreView: {
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      form: {
        ctIssue: undefined,
        share: undefined,
        use: undefined,
        belong: undefined,
        revise: undefined,
        desc: undefined,
        Items: undefined,
        name: undefined,
        editorVal: undefined,
        createDate: undefined,
        updateDate: undefined,
        from: undefined
      },
      list: [],
      currentList: [],
      currentPage: 1,
      totalPages: 0,
      pageSize: 9999,
      paramLoading: false,
      etag: undefined,
      previewData: '',
      isPreView: false,
      currentValue: this.editVal
    };
  },
  methods: {
    updateCurrentValue: function updateCurrentValue() {
      this.currentValue = this.$refs.editor.getEditorVal();
    },
    toPreviewData: function toPreviewData() {
      this.isPreView = true;
      var tableDatas = this.$refs.editor.getTableData();
      this.previewData = _toPreviewData(this.form.editorVal, tableDatas, this.sysParams);
    },
    toView: function toView() {
      this.updateCurrentValue();
      this.toPreviewData();
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    getSubjectOptions: function getSubjectOptions() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, res, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$awaitTo(getAccountList(_this.taskId, {
                PageNumber: 1,
                PageSize: 9999
                // SortBy:this.sortBy,
                // SearchQuery:this.searchKey !== '' && this.searchKey !== undefined ? `c12AccountName.contains("${this.searchKey}")` : undefined
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              res = _yield$_this$$awaitTo2[1];
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              data = res.data;
              if (!Array.isArray(data)) {
                _context.n = 3;
                break;
              }
              return _context.a(2, Promise.resolve(data));
            case 3:
              return _context.a(2, Promise.reject());
          }
        }, _callee);
      }))();
    },
    getParamDetail: function getParamDetail(id) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, res, headers, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.loading = true;
              _context2.n = 1;
              return _this2.$awaitTo(_getParamDetail(_this2.confirmId, _this2.taskId, id));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              res = _yield$_this2$$awaitT2[1];
              _this2.loading = false;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, Promise.reject());
            case 2:
              headers = res.headers, data = res.data;
              _this2.etag = headers.etag;
              return _context2.a(2, Promise.resolve(transformParamsToFormV2(data)));
          }
        }, _callee2);
      }))();
    },
    createParam: function createParam(item) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.loading = true;
              _context3.n = 1;
              return _this3.$awaitTo(_createParam(_this3.confirmId, _this3.taskId, [transformParamsToDataV2(item)]));
            case 1:
              _yield$_this3$$awaitT = _context3.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 2);
              err = _yield$_this3$$awaitT2[0];
              res = _yield$_this3$$awaitT2[1];
              _this3.loading = false;
              if (!err) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, Promise.reject());
            case 2:
              _this3.getParamsList();
              _this3.$message.success('操作成功');
              return _context3.a(2, Promise.resolve());
          }
        }, _callee3);
      }))();
    },
    removeParam: function removeParam(item) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this4.loading = true;
              _context4.n = 1;
              return _this4.$awaitTo(_removeParam(_this4.confirmId, _this4.taskId, item.c21Id));
            case 1:
              _yield$_this4$$awaitT = _context4.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 2);
              err = _yield$_this4$$awaitT2[0];
              res = _yield$_this4$$awaitT2[1];
              _this4.loading = false;
              if (!err) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, Promise.reject());
            case 2:
              _this4.getParamsList();
              _this4.$message.success('操作成功');
              return _context4.a(2, Promise.resolve());
          }
        }, _callee4);
      }))();
    },
    updateParam: function updateParam(id, options) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$_this5$$awaitT, _yield$_this5$$awaitT2, err, data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this5.loading = true;
              _context5.n = 1;
              return _this5.$awaitTo(_updateParam(_this5.confirmId, _this5.taskId, id, transformParamsToDataV2(options), {
                'If-Match': _this5.etag
              }));
            case 1:
              _yield$_this5$$awaitT = _context5.v;
              _yield$_this5$$awaitT2 = _slicedToArray(_yield$_this5$$awaitT, 2);
              err = _yield$_this5$$awaitT2[0];
              data = _yield$_this5$$awaitT2[1];
              _this5.loading = false;
              if (!err) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, Promise.reject());
            case 2:
              _this5.$message.success('操作成功');
              _this5.getParamsList();
              return _context5.a(2, Promise.resolve());
          }
        }, _callee5);
      }))();
    },
    submit: function submit() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$refs.editor.checkForm();
            case 1:
              if (!(_this6.type === 'update')) {
                _context6.n = 2;
                break;
              }
              _context6.n = 2;
              return _this6.tips();
            case 2:
              _this6.$emit('submit', {
                data: _this6.form.editorVal,
                params: _this6.currentList
              });
            case 3:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    tips: function tips() {
      var _this7 = this;
      return new Promise(function (resolve) {
        _this7.$alert('编辑状态需要点击保存按钮才会保存数据', '温馨提示', {
          confirmButtonText: '确定',
          callback: function callback(action) {
            resolve();
          }
        });
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.getParamsList();
    },
    getParamsList: function getParamsList() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _yield$_this8$$awaitT, _yield$_this8$$awaitT2, err, res, headers, data, pagination;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _this8.paramLoading = true;
              _context7.n = 1;
              return _this8.$awaitTo(getParamList(_this8.confirmId, _this8.taskId, {
                PageNumber: _this8.currentPage,
                PageSize: _this8.pageSize,
                SearchQuery: ''
              }));
            case 1:
              _yield$_this8$$awaitT = _context7.v;
              _yield$_this8$$awaitT2 = _slicedToArray(_yield$_this8$$awaitT, 2);
              err = _yield$_this8$$awaitT2[0];
              res = _yield$_this8$$awaitT2[1];
              _this8.paramLoading = false;
              if (!err) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2);
            case 2:
              headers = res.headers, data = res.data;
              if (Array.isArray(data)) {
                _this8.list = data.map(function (params) {
                  return transformParamsToFormV2(params);
                });
              }
              pagination = headers['x-pagination'];
              if (pagination) {
                _this8.totalPages = JSON.parse(pagination).totalCount;
              }
            case 3:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    success: function success(data) {
      this.$emit('submit', data);
    },
    paramsChange: function paramsChange(type, data, list) {
      // console.log(type,data,list)
      this.currentList = list;
    },
    transformToData: function transformToData(data) {
      return {};
    }
  },
  created: function created() {
    this.form = _objectSpread(_objectSpread({}, transformToForm(this.data)), {}, {
      editorVal: this.editVal
    });
    if (this.type === 'create') {
      this.list = this.params.map(function (item) {
        return transformParamsToForm(item);
      });
    }
    if (this.confirmId) {
      this.getParamsList();
    }
  }
};